<template>
    <div>
        <el-form label-width="70px" :label-position="'right'">
            <el-row :gutter="10">
                <el-form-item label="占用时间">
                    <el-input-number v-model="$parentInfo.studentCart.dialog_HasTime.hasTime"
                                     size="small"></el-input-number>
                </el-form-item>
            </el-row>
        </el-form>
        <div class="text-right">
            <el-button type="primary" size="small" @click="handleChangeTime()"
                       :loading="$parentInfo.studentCart.dialog_HasTime.button_loading">确 定
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        mounted() {
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleMessage();
        },
        methods: {
            handleMessage() {
                this.$parentInfo.studentCart.dialog_HasTime.hasTime = this.$store.state.modal.data.hasTime;
            },
            // 修改
            handleChangeTime() {
                this.$parentInfo.studentCart.dialog_HasTime.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'changeTime', {
                    'card_id': this.$store.state.modal.data.cart_id,
                    'hasTime': this.$parentInfo.studentCart.dialog_HasTime.hasTime,
                });
            },
        }
    };
</script>

<style scoped>
</style>
